import { User } from '@auth0/auth0-angular';
import { Observable, of } from 'rxjs';
import { GetTokenSilentlyOptions } from '@auth0/auth0-spa-js';
import { Injectable } from '@angular/core';
import { UnsecuredJWT } from 'jose';
import { DEFAULT_SCOPES } from '../../../../../e2e/mock-responses/settings.example';

/**
 * Ideally this class would override from the @auth0/auth0-angular {@link AuthService} but due to
 * typing issues it is not trivial to override the {@link #getAccessTokenSilently} method.
 * Instead, the properties and methods must be manually kept in sync with {@link AuthService} (at
 * least for those properties that are actually being used, other properties can be ignored).
 */
@Injectable()
export class MockAuthService {
  /**
   * Emits boolean values indicating the loading state of the SDK.
   */
  readonly isLoading$ = of(false);

  /**
   * Emits boolean values indicating the authentication state of the user. If `true`, it means a user has authenticated.
   * This depends on the value of `isLoading$`, so there is no need to manually check the loading state of the SDK.
   */
  readonly isAuthenticated$ = of(true);

  /**
   * Emits details about the authenticated user, or null if not authenticated.
   */
  readonly user$ = of({
    'http://mateco.eu/oid': '1511e304-d1ad-4759-a0f8-9d62dfa2b567',
    'http://mateco.eu/timezone': 'Europe/Brussels',
    displayName: 'Mock User',
    email: 'q.planning@mateco.eu',
  } as User);

  getAccessTokenSilently(options?: GetTokenSilentlyOptions): Observable<string> {
    const token = new UnsecuredJWT({
      scope: DEFAULT_SCOPES,
    })
      .setIssuedAt()
      .setIssuer('FakeIssuer')
      .setAudience('qplanning')
      .setExpirationTime('2h')
      .encode();

    return of(token);
  }
}
